const UserActionsActionType = {
  GET_USER_ACTIONS: 'GET_USER_ACTIONS',
  SAVE_USER_ACTIONS: 'SAVE_USER_ACTIONS',
  RESET_USER_ACTIONS: 'RESET_USER_ACTIONS',

  GET_USER_RECENT_ACTIONS: 'GET_USER_RECENT_ACTIONS',
  SAVE_USER_RECENT_ACTIONS: 'SAVE_USER_RECENT_ACTIONS',
  RESET_USER_RECENT_ACTIONS: 'RESET_USER_RECENT_ACTIONS',
};

export default UserActionsActionType;
